// extracted by mini-css-extract-plugin
export default {"root":"ExecuteMessageProposalForm_root__mBuUs","section":"ExecuteMessageProposalForm_section__NbOZ9","button":"ExecuteMessageProposalForm_button__r2FSP"};